import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'recompose/compose';

import QTip from 'components/QuickenControls/QTip';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles/index';
import QCardIconOn from '@material-ui/icons/Chat';
import QCardIconOff from '@material-ui/icons/ChatBubbleOutline';

const styles = (_theme) => ({
  buttonRoot: {
    outline: 'none !important',
    fontSize: 'unset',
  },
});

const QCardToggleButton = (props) => {
  const { classes, size, qCardsOn } = props;

  const QCardIcon = qCardsOn ? QCardIconOn : QCardIconOff;

  return (
    <QTip
      placement="right"
      title={`QCards are currently ${qCardsOn ? 'on' : 'off' }`}
    >
      <IconButton
        id={qCardsOn ? 'qCardsTrue' : 'qCardsFalse'}
        aria-label="QCard Toggle"
        classes={{
          root: classes.buttonRoot,
        }}
        onClick={(e) => {
          props.onClick(!qCardsOn);
          e.stopPropagation();
        }}
      >
        <QCardIcon style={{ fontSize: size }} />
      </IconButton>
    </QTip>
  );
};

QCardToggleButton.propTypes = {
  classes: PropTypes.object,
  size: PropTypes.number,
  qCardsOn: PropTypes.bool,
  onClick: PropTypes.func,
};

const mapStateToProps = () => ({
});

const mapDispatchToProps = () => ({
});

export default compose(
  withStyles(styles, { name: 'QCardToggleButton' }),
  connect(mapStateToProps, mapDispatchToProps)
)(QCardToggleButton);
